export default "/images/1fa78d16dded941003b89714c27a2078.png";